import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { DashboardShell } from "@/components/layout/DashboardShell";
import { Metric, StatusPill } from "@/components/common";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Package, FileText, Loader2, Plus } from "lucide-react";

const shipperNav = [
  { to: "/shipper", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/ship", label: "Create Shipment", icon: Plus },
  { to: "/find-loads", label: "Browse Loads", icon: Package },
];

export default function ShipperDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/shipper/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <DashboardShell nav={shipperNav}><div className="py-24 grid place-items-center"><Loader2 className="animate-spin text-xd-orange" size={32} /></div></DashboardShell>;

  return (
    <DashboardShell nav={shipperNav} title="Shipper Dashboard">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Metric testid="ship-total" label="Total Quotes" value={d.total_quotes} accent="orange" />
        <Metric testid="ship-new" label="Awaiting Response" value={d.new_quotes} accent="blue" />
        <Metric testid="ship-responded" label="Responded" value={d.responded} accent="green" />
        <Metric testid="ship-active" label="Active Shipments" value={d.active_shipments} accent="white" />
      </div>

      <div className="mt-6 flex items-center justify-between">
        <h2 className="font-heading text-xl font-bold">Your quote requests</h2>
        <Button asChild data-testid="ship-new-btn" className="bg-xd-orange hover:bg-xd-orangeH text-white"><Link to="/ship"><Plus size={16} className="mr-2" /> New Request</Link></Button>
      </div>

      {d.quotes.length === 0 ? (
        <div className="mt-4 py-16 text-center border border-dashed border-xd-border rounded-xl text-xd-muted">No quote requests yet. Submit a "Ship With XD" request to get started.</div>
      ) : (
        <div className="mt-4 space-y-3">
          {d.quotes.map((q) => (
            <div key={q.id} data-testid={`quote-${q.xd_ref}`} className="bg-xd-paper border border-xd-border rounded-xl p-5">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <div className="flex items-center gap-2"><span className="font-mono text-xs text-xd-dim">{q.xd_ref}</span><StatusPill status={q.status} /></div>
                  <h3 className="mt-1 font-heading font-bold">{q.origin} → {q.destination}</h3>
                  <p className="text-sm text-xd-muted">{q.commodity} · {q.weight ? `${q.weight.toLocaleString()} lbs` : "—"} · {q.trailer_type || "Any trailer"}</p>
                </div>
                <div className="text-right text-xs text-xd-dim">Requested {new Date(q.created_at).toLocaleDateString()}</div>
              </div>
              {q.admin_response && <div className="mt-3 rounded-lg bg-xd-blue/10 border border-xd-blue/30 p-3 text-sm"><span className="font-semibold text-xd-blue">XD Response: </span>{q.admin_response}</div>}
            </div>
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
